export const productNotFound = {
  WereSorry: "We're sorry,",
  UnfortunatelyTheProduct: "We could not locate that product for you",
  YouCanTry:
    "We are always working to expand our selection to meet your needs. Try searching our catalog to find products that are available.",
  SearchCatalog: "Search our catalog",
} as const;
